import React from 'react';
import { Phone, Instagram, MapPin, Heart } from 'lucide-react';
import { LOGO_URL, CONTACT_INFO } from '../data/mock';
import { Separator } from './ui/separator';

const Footer = () => {
  return (
    <footer className="bg-neutral-900 border-t border-neutral-800 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Logo and Brand */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-amber-500/50 shadow-lg shadow-amber-500/10 mb-4">
            <img src={LOGO_URL} alt="Mr Sweet" className="w-full h-full object-cover" />
          </div>
          <h3 className="text-2xl font-bold text-white">Mr Sweet</h3>
          <p className="text-neutral-400 text-sm">Cafe & Restaurant</p>
        </div>

        <Separator className="bg-neutral-800 my-6" />

        {/* Contact Info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
          <a
            href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`}
            className="flex flex-col items-center space-y-2 p-4 rounded-xl bg-neutral-800/50 hover:bg-neutral-800 transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center group-hover:bg-amber-500/30 transition-colors">
              <Phone className="w-5 h-5 text-amber-400" />
            </div>
            <span className="text-neutral-300 group-hover:text-amber-400 transition-colors font-medium">
              {CONTACT_INFO.phone}
            </span>
          </a>

          <a
            href={CONTACT_INFO.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center space-y-2 p-4 rounded-xl bg-neutral-800/50 hover:bg-neutral-800 transition-colors group"
          >
            <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center group-hover:bg-amber-500/30 transition-colors">
              <Instagram className="w-5 h-5 text-amber-400" />
            </div>
            <span className="text-neutral-300 group-hover:text-amber-400 transition-colors font-medium">
              @{CONTACT_INFO.instagram}
            </span>
          </a>

          <div className="flex flex-col items-center space-y-2 p-4 rounded-xl bg-neutral-800/50">
            <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center">
              <MapPin className="w-5 h-5 text-amber-400" />
            </div>
            <span className="text-neutral-300 font-medium">
              {CONTACT_INFO.address}
            </span>
          </div>
        </div>

        <Separator className="bg-neutral-800 my-6" />

        {/* Copyright */}
        <div className="text-center">
          <p className="text-neutral-500 text-sm flex items-center justify-center space-x-1">
            <span>Made with</span>
            <Heart className="w-4 h-4 text-red-500 fill-red-500" />
            <span>Mr Sweet © {new Date().getFullYear()}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;